import React, { Component } from "react"

export default class NoFlights extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="flights__no-results">
          <div className="section-header section-header--small">
            <p>{this.props.noResultsText}</p>
            <div>
              <h2>{this.props.noResultsHeader}</h2>
              <p>{this.props.noResultsSubHeader}</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}
